export default "__VITE_ASSET__DRi7eD9i__"